import { render } from "./XTelInput.vue?vue&type=template&id=24637d06"
import script from "./XTelInput.vue?vue&type=script&lang=js"
export * from "./XTelInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__